import {create} from 'zustand';

import {
  NotificationId,
  NotificationItem,
} from 'app/components/core/Notifications/Notification';

type NotificationsState = {
  notifications: Map<NotificationId, NotificationItem>;
  addNotification: (notification: NotificationItem) => void;
  removeNotification: (id: NotificationId) => void;
};

export const useNotificationsStore = create<NotificationsState>(set => ({
  notifications: new Map(),

  addNotification: notification =>
    set(state => ({
      notifications: new Map(
        state.notifications.set(notification.id, notification),
      ),
    })),

  removeNotification: id =>
    set(state => {
      state.notifications.delete(id);

      return {
        notifications: new Map(state.notifications),
      };
    }),
}));
